import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { locale } from 'dayjs';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Layout from './components/Layout';

locale('en');

const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={defaultQueryClient}>
        <Layout>
          <App />
        </Layout>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
